import Moment from 'moment';
import VuexPersist from 'vuex-persist';

import GlobalState from '@/store/state';
import AppointmentState from '@/store/modules/appointment/state';
import CompanyState from '@/store/modules/company/state';
import ScheduleState from '@/store/modules/schedule/state';

const DEFAULT_EXPIRATION_DAYS = 7;
const DEFAULT_STORE_STATE = {};

const reducer = state => ({
  Auth: state.Auth || {},
  Appointment: state.Appointment || {},
  Company: {
    company: state.Company
      ? state.Company.company
      : {},
  },
  lastAccessedDate: state.lastAccessedDate, // this should left falsy for release compatibility
  Schedule: {
    filters: state.Schedule
      ? state.Schedule.filters
      : {},
  },
  User: state.User || {},
});

const defaultReducerState = state => ({
  ...reducer(state),
  Appointment: AppointmentState,
  Company: {
    company: CompanyState.company,
  },
  lastAccessedDate: GlobalState.lastAccessedDate,
  Schedule: {
    filters: ScheduleState.filters,
  },
});

const restoreState = (key, storage) => {
  const newStorage = storage;
  if (newStorage[key]) {
    try {
      const { VUE_APP_PERSISTED_STATE_EXPIRATION_DAYS } = process.env;
      const jsonStorage = JSON.parse(newStorage[key]);
      const { lastAccessedDate } = jsonStorage;

      const lastAccessedDateMoment = new Moment(lastAccessedDate);
      let expirationDays = Number.parseInt(VUE_APP_PERSISTED_STATE_EXPIRATION_DAYS, 10);
      if (Number.isNaN(expirationDays) || expirationDays <= 0) {
        expirationDays = DEFAULT_EXPIRATION_DAYS;
      }
      const expirationDateMoment = lastAccessedDateMoment
        .clone()
        .add(expirationDays, 'd');
      const todayMoment = new Moment();

      return expirationDateMoment.isBefore(todayMoment)
        ? defaultReducerState(jsonStorage)
        : jsonStorage;
    } catch (err) {
      return DEFAULT_STORE_STATE;
    }
  }
  return DEFAULT_STORE_STATE;
};

const generatePlugin = () => {
  const { VUE_APP_PERSISTED_STATE_KEY } = process.env;
  return new VuexPersist({
    key: VUE_APP_PERSISTED_STATE_KEY,
    storage: window.localStorage,
    reducer,
    restoreState,
  });
};

export default generatePlugin;
export {
  defaultReducerState,
  generatePlugin,
  reducer,
  restoreState,
};
